import { gtmPushEvent, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';

const watchlistOnClick = (dataAction, listingID, listingTypes, routes) => {

    return sandhillsRequest({
        url: routes.WatchListClick.replace("{0}", dataAction),
        method: 'post',
        data: {
            'ListingID': listingID,
            'ListingTypes': listingTypes
        },
        errorHandling: {
            useConsole: false,
            useAlert: false
        }
    }).then(response => {
        if (response.success) {
            if (dataAction == 'add') {
                gtmPushEvent('watchlist-add-click');
            }
        } else if (!response.IsAuthenticated) {
            var mappedListingTypes = listingTypes.map(function (item) {
                return 'ListingTypes=' + item + '&';
            }).join('');

            window.location.href = routes.SSO + '?to=' + encodeURIComponent('https://' + window.location.hostname + '/watchlist/' + dataAction + '/' + listingID + '?' + mappedListingTypes + 'to=' + encodeURIComponent(window.location.href));
            
        }

        return response;
    });
};

export {
    watchlistOnClick
};